import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import { motion, AnimatePresence } from 'framer-motion';

const API_URL = process.env.REACT_APP_API_URL || 'https://orbitronix.ge/api/';

const MyProjects = () => {
    const { user, loading: authLoading } = useAuth();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_URL}portfolios.php?assigned_user_id=${user.id}`);
                const data = await response.json();
                setProjects(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching assigned projects:', error);
            }
            setLoading(false);
        };

        if (user) fetchProjects();
    }, [user]);

    if (authLoading || !user) return null;

    return (
        <Layout hideScrollbar>
            <main className="page_content pt-150 pb-120">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                        <h1 className="text-white">My Projects</h1>
                        <span className="badge bg-primary fs-6 py-2 px-3">Assigned to: {user.username}</span>
                    </div>

                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : projects.length === 0 ? (
                        <div className="text-center py-5">
                            <i className="fas fa-folder-open fa-4x text-white-50 mb-3"></i>
                            <h3 className="text-white-50">No Projects Assigned Yet</h3>
                            <p className="text-muted mt-2">Any private projects or offers assigned to you will appear here.</p>
                        </div>
                    ) : (
                        <motion.div layout className="row">
                            <AnimatePresence mode="popLayout">
                                {projects.map((project, index) => {
                                    let imgUrl = project.image;
                                    if (imgUrl && !imgUrl.startsWith('http') && !imgUrl.startsWith('static')) {
                                        imgUrl = API_URL + imgUrl;
                                    }
                                    
                                    return (
                                        <motion.div
                                            key={project.id}
                                            layout
                                            initial={{ opacity: 0, scale: 0.8 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.8 }}
                                            transition={{ duration: 0.4, delay: index * 0.05 }}
                                            className="col-lg-4 col-md-6 mb-30"
                                        >
                                            <div className="project-card item-details-widget h-100 p-0 overflow-hidden d-flex flex-column">
                                                <div className="project-img-wrapper pos-rel">
                                                    <img src={imgUrl || '/images/logo.png'} alt={project.title} className="w-100" style={{height: '220px', objectFit: 'cover'}} />
                                                    {!project.is_public && (
                                                        <span className="badge bg-danger position-absolute top-0 end-0 m-3 p-2">
                                                            <i className="fas fa-lock me-1"></i> Private
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="p-4 d-flex flex-column flex-grow-1">
                                                    <span className="text-primary small fw-bold mb-2 text-uppercase">{project.category}</span>
                                                    <h3 className="text-white mb-3">{project.title}</h3>
                                                    <p className="text-white-50 small flex-grow-1">{project.summary}</p>
                                                    <div className="mt-4 pt-3 border-top border-secondary d-flex justify-content-between align-items-center">
                                                        <Link to={`/en/portfolio/${project.slug}`} className="btn-read-more">
                                                            View Details <i className="fas fa-arrow-right ms-1"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </AnimatePresence>
                        </motion.div>
                    )}
                </div>
            </main>
            <style>{`
                .project-card { background: rgba(255,255,255,0.03); border-radius: 20px; border: 1px solid rgba(255,255,255,0.05); transition: 0.3s; }
                .project-card:hover { transform: translateY(-10px); border-color: rgba(108, 92, 231, 0.4); box-shadow: 0 15px 30px rgba(0,0,0,0.3); }
                .btn-read-more { color: #6c5ce7; text-decoration: none; font-weight: 600; transition: 0.3s; }
                .btn-read-more:hover { color: #fff; }
                .border-secondary { border-color: rgba(255,255,255,0.1) !important; }
            `}</style>
        </Layout>
    );
};

export default MyProjects;
